
import React from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, 
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { CheckCircle, AlertCircle } from "lucide-react";

interface ScheduleClassesDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isScheduling: boolean;
  scheduleResult: { success: boolean; created: number; error?: string } | null;
  onScheduleClasses: () => void;
}

const ScheduleClassesDialog: React.FC<ScheduleClassesDialogProps> = ({
  isOpen,
  onOpenChange,
  isScheduling,
  scheduleResult,
  onScheduleClasses
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Schedule Classes for 8 Weeks</AlertDialogTitle>
          <AlertDialogDescription>
            This will automatically create class entries for the next 8 weeks based on your template schedule.
            Classes will only be created for days and times that don't already have a class scheduled.
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        {scheduleResult && (
          <Alert variant={scheduleResult.success ? "default" : "destructive"} className="mt-4">
            {scheduleResult.success ? (
              <CheckCircle className="h-4 w-4" />
            ) : (
              <AlertCircle className="h-4 w-4" />
            )}
            <AlertTitle>
              {scheduleResult.success ? "Scheduling Complete" : "Scheduling Error"}
            </AlertTitle>
            <AlertDescription>
              {scheduleResult.success 
                ? `Successfully created ${scheduleResult.created} new classes.`
                : scheduleResult.error || "An error occurred during scheduling."}
            </AlertDescription>
          </Alert>
        )}
        
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isScheduling}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={(e) => {
              e.preventDefault();
              onScheduleClasses();
            }}
            disabled={isScheduling}
          >
            {isScheduling ? "Scheduling..." : "Schedule Classes"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ScheduleClassesDialog;
